import { jsx as _jsx } from "react/jsx-runtime";
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
import { useBreakpoint } from '../../hooks';
import { PAGE_BREAKPOINTS } from '../../constants/commonConstants';
import { FooterContainer } from './FooterContainer';
export const Footer = ({ children, isCheckout = false, withSalesforceChat = false, footerDesignUpdate = false }) => {
    const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
    return (_jsx(FooterContainer, { isCheckout: isCheckout, withSalesforceChat: withSalesforceChat, footerDesignUpdate: footerDesignUpdate, children: isMD ? _jsx(CatLayoutContainer, { children: children }) : children }));
};
